<template>
  <div class="px-4">
    <form @submit.prevent="send" method="post">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="col-span-1 md:col-span-2 space-y-2">
          <label class="block w-full" for="contact_full_name">Nome Completo</label>
          <input class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg shadow-sm border-default-100" type="text"  id="contact_full_name"
            name="contact_full_name"
            v-model="dataForm.name"
            placeholder="Ex.: João Batista"
            required>
        </div>
        <div class="col-span-1 space-y-2">
          <label class="block w-full" for="contact_email">E-mail</label>
          <input class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg shadow-sm border-default-100" type="text"  id="contact_email"
            name="contact_email"
            v-model="dataForm.email"
            placeholder="Ex.: joao@email.com"
            required>
        </div>
        <div class="col-span-1 space-y-2">
          <label class="block w-full" for="contact_phone">Telefone</label>
          <input class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg shadow-sm border-default-100" type="text"  id="contact_phone"
            name="contact_phone"
            v-model="dataForm.phone"
            placeholder="Ex.: (00) 00000-0000"
            required>
        </div>
        <div class="col-span-1 md:col-span-2 space-y-2">
          <label class="block w-full" for="contact_assunt">Assunto</label>
          <input class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg shadow-sm border-default-100" type="text"  id="contact_assunt"
            name="contact_assunt"
            v-model="dataForm.subject"
            required>
        </div>
        <div class="col-span-1 md:col-span-2 space-y-2">
          <label class="block w-full" for="contact_message">Menssagem</label>
          <textarea
            class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg shadow-sm border-default-100"
            name="contact_message"
            v-model="dataForm.message"
            rows="5"
          ></textarea>
        </div>
        <div class="col-span-1 md:col-span-2">
          <button v-show="!dataSend" class="block w-full p-4 font-semibold text-white rounded-lg shadow btn bg-default-500 hover:bg-default-600">Enviar</button>

          <button v-show="dataSend" class="block w-full p-4 font-semibold text-white rounded-lg shadow btn bg-default-400" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Enviando...
          </button>
        </div>
        <div class="col-span-1 md:col-span-2">
          <span v-show="msg.isActive" :class="msg.type" class="block w-full rounded-lg p-2 bg-green-100 text-green-900">
            {{msg.title}}
          </span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ContactUs from "./../api/models/ContactUs";

export default {
	name: "ContactUsComponent",
	data() {
		return {
			dataForm: {},
      msg: {},
			dataSend: false,
		};
	},

	methods: {
		send() {
      this.dataSend = true
			ContactUs.post(this.dataForm).then(response => {
        console.log(response);
        if (response.status === 200) {
          this.msg = {
            isActive: true,
            title: "Enviado com Sucesso!",
            description: response.data.message,
            type: "text-success",
          };
          this.dataForm = {};
          this.dataSend = false;
          setTimeout(
            function () {
              this.msg.isActive = false;
            }.bind(this), 10000
          );
        } else {
          this.msg = {
            isActive: true,
            title:
              "Não foi possível enviar a mensagem, tente novamente mais tarde!",
              description: response.data.message,
              type: "text-red-500",
          };
          setTimeout(
            function () {
              this.msg.isActive = false;
              this.dataSend = false;
            }.bind(this), 3000
          );
        }
      })
		},
	},
};
</script>

<style scoped>
</style>
